import { Breadcrumbs, Button, Card, CardActions, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import HomeIcon from '@material-ui/icons/Home';
import axios from 'axios';
import { Form, Formik, FormikProps } from 'formik';
import { FunctionComponent, useEffect, useState } from 'react';
import { pdfjs } from 'react-pdf';
import { Link } from 'react-router-dom';
import { LoadingButton } from '../components/atoms/inputs/LodingButton';
import { PdfViewer } from '../components/atoms/inputs/PdfViewer';
import { AppShell } from '../components/molecules/app-shell/AppShell';
import { useStore } from '../store';
import { ApiResponse } from '../types';
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const useStyles = makeStyles((theme) => ({
    controlPaper: {
        width: "100%",
        padding: "8px",
    },
    link: {
        display: 'flex',
        textDecoration: 'none',
    },
    icon: {
        marginRight: theme.spacing(0.5),
        width: 20,
        height: 20,
    },

}))

const getYearRange = (retirementYear: number) => {
    const currentYear = new Date().getFullYear();
    // const startYear = retirementYear || 2016;
    const startYear = (retirementYear >= 2021)?retirementYear:2021;
    const yearList: number[] = [];

    for (let i = startYear; i <= currentYear; i++) {
        yearList.push(i);
    }
    return yearList.reverse();
}

type FormikForm = {
    year: string,
    file: any,
    fileName?: string,
}

type AnnualStatementPageProps = {
}

type PensionerApiData = {
    name: string,
    spouseName: string,
    pensionerAddr: string,
    dobSpouse: string,
    dtRet: string,
    categoryPensioner: string,
    lastPenMonth: string,
    pensionerType: string,
    aadharNo: string,
    panId: string,
    contactNo: string,
    emailId: string,
    bankAccNum: string,
}

type PensionerProfileState = {
    loading: boolean,
    error: string,
    profile: Array<PensionerApiData>
}

export const AnnualStatementPage: FunctionComponent<AnnualStatementPageProps> = () => {
    const classes = useStyles()
    const store = useStore()
    const [profileData, setProfile] = useState<PensionerProfileState>({ loading: true, error: '', profile: [] });

    useEffect(() => {
        fetchProfile()
    }, []);

    const fetchProfile = async () => {
        axios.get<ApiResponse<{ profile: PensionerApiData[] }>>(`api/pensioner/profile-details`, {
            headers: {
                'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}`
            }
        })
            .then(
                ({ data: resp }) => {
                    if (resp.status === "success") {
                        const profile: PensionerApiData[] = resp.data.profile;
                        setProfile({ loading: false, error: '', profile: profile })
                    } else {
                        setProfile({ loading: false, error: resp.message, profile: [] })
                    }
                },
                () => { setProfile({ loading: false, error: "Network Error", profile: [] }) }
            )
    }

    const retirementDate = profileData?.profile[0]?.dtRet;
    let retirementYear = 0;
    try {
        retirementYear = new Date(retirementDate).getFullYear();
    } catch (e) {
        retirementYear = 0;
    }

    const yearRange = profileData.loading ? [] : getYearRange(retirementYear);

    const getFiscalYear = (y: number) => `${y}-${(y + 1).toString().slice(-2)}`

    return (
        <AppShell>
            <Grid container
                spacing={3}
                direction="column"
                justify="space-around"
                alignItems="stretch">
                <Formik
                    initialValues={{
                        year: getFiscalYear(new Date().getFullYear()),
                        file: null,
                    }}
                    validate={(values) => {
                    }}
                    onSubmit={async (values, { setSubmitting, setFieldValue, setFieldTouched, setFieldError }) => {
                        setSubmitting(true)
                        setFieldValue('fileName', `annual-statement-${values.year}.pdf`)
                        setFieldValue('file', {
                            url: `${process.env.REACT_APP_API_ROOT}api/pensioner/annual-statement/${values.year.toString().slice(0, 4)}`,
                            httpHeaders: { 'Authorization': `Bearer ${store.auth.jwt}`, 'JWT': `Bearer ${store.auth.jwt}` },
                        })
                    }}
                >
                    {
                        ({ values, isSubmitting, isValid, setFieldValue, setValues, handleChange, setSubmitting }: FormikProps<FormikForm>) =>
                            <Form>
                                <Grid
                                    item
                                    container
                                    spacing={3}
                                    direction="column"
                                    justify="space-around"
                                    alignItems="stretch"
                                >
                                    <Grid item>
                                        <Card elevation={3}>
                                            <CardContent>
                                                <Grid container spacing={3} direction="column" justify="space-around"
                                                    alignItems="stretch">
                                                    <Grid item>
                                                        <Breadcrumbs>
                                                            <Link to="/" className={classes.link}>
                                                                <Typography gutterBottom variant="h5" component="h2">
                                                                    <HomeIcon className={classes.icon} />Home</Typography>
                                                            </Link>
                                                            <Typography gutterBottom variant="h5" component="h2">Annual Pension Statement (পেনশন প্রদানের বার্ষিক বিবরণ)</Typography>
                                                        </Breadcrumbs>
                                                    </Grid>
                                                    <Grid item>
                                                        <FormControl variant="filled" fullWidth disabled={isSubmitting}>
                                                            <InputLabel id="demo-simple-select-filled-label">Year (বছর)</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-filled-label"
                                                                id="demo-simple-select-filled"
                                                                name="year"
                                                                value={values.year}
                                                                onChange={handleChange}
                                                            >
                                                                {
                                                                    yearRange.map(y => <MenuItem value={getFiscalYear(y)}>{getFiscalYear(y)}</MenuItem>)
                                                                }
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </CardContent>
                                            <CardActions>
                                                <Button type="reset" size="large" color="primary" variant="contained" disabled={isSubmitting}>
                                                    Reset (রিসেট)
                                                </Button>
                                                <LoadingButton type="submit" size="large" color="primary" variant="contained" loading={isSubmitting}>
                                                    Load Statement (লোড স্টেটমেন্ট)
                                                </LoadingButton>

                                                <Link to="/" className={classes.link}>
                                                    <Button variant='contained' color='primary' size='large'>
                                                        Back (পিছনে)
                                                    </Button>
                                                </Link>

                                            </CardActions>
                                        </Card>
                                    </Grid>
                                    {
                                        !!values.file && !!values.fileName &&
                                        < Grid item>
                                            <Card>
                                                <CardContent>
                                                    <PdfViewer
                                                        downloadFileName={values.fileName}
                                                        file={values.file}
                                                        onDocumentLoadSuccess={() => { setSubmitting(false) }}
                                                        onDocumentLoadError={() => { setSubmitting(false) }}
                                                        error={
                                                            <>
                                                                <Typography
                                                                    variant="h6"
                                                                    component="h6"
                                                                    style={{ textAlign: "center" }}
                                                                    color="secondary">
                                                                    Annual pension statement is not available for the chosen period. Please contact the pension cell.<br /> 
                                                                    <b>(নির্বাচিত সময়ের জন্য বার্ষিক পেনশন বিবরণ উপলব্ধ নেই। দয়া করে পেনশন সেলের সাথে যোগাযোগ করুন।)</b></Typography>
                                                            </>
                                                        }
                                                    />
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    }
                                </Grid>
                            </Form>
                    }
                </Formik>
            </Grid>
        </AppShell >
    )
}